$(function() {
    var $timeframeOptions = $('.js-timeframe__options');
    var $pickupOptions = $('.js-pickup__options');
    var $loadingIcon = $('<i/>').addClass('fa fa-cog fa-spin');

    // Select shipping method option on cart page
    $('.js-cart-shipping-option').on('change', function(evt){
        $.cookie('shippingoption', $(this).val(), {path: '/'});
    });

    // Select shipping method option
    $('.js-change-shipping-option').on('click', function(evt) {
        evt.preventDefault();
        // Hide current option
        $('.js-pickup, .js-timeframe').collapse('hide');

        // Reset
        $('.js-timeframe__option, .js-timeframe__preferred-shipping-date, .js-pickup__location > input').val('');
        $timeframeOptions.html('');
        $('.js-timeframe__info').removeClass('hidden');
        $pickupOptions.html('');
        $('.js-shipping-option').prop('checked', false);
        update_cost();

        // Show list of options
        $('.js-shipping-options').collapse('show');
        return false;
    });

    $('.js-shipping-option').on('change', function() {
        var option = $(this).val();

        var $shipToInvoice = $('#ship-to-invoice');
        $shipToInvoice.parents('.checkbox').removeClass('hidden');

        if(option === 'timeframe') {
            getAvailableTimeFrames(true);
        } else if (option === 'pickup') {
            if(!$shipToInvoice.is(':checked')){
                $shipToInvoice.click();
            }
            $shipToInvoice.parents('.checkbox').addClass('hidden');

            var zipcode = $('.js-zipcode-address').val();
            $('.js-pickup__zipcode').val(zipcode);
        }
        if(option != 'default') {
            $('.js-' + option).collapse('show');
            $('.js-shipping-options').collapse('hide');
        }
        $.cookie('shippingoption', option, {path: '/'});
    });

    // Timeframe
    $('.js-address__trigger').on('blur.getTimeFrames', function(evt) {
        getAvailableTimeFrames(false);
    });

    function getAvailableTimeFrames(forceOnHidden) {
        var shippingMethodId = $('.js-shipping-method-id').val();
            invoiceAddressForShipping = $('#ship-to-invoice').is(':checked'),
            timeframesVisible = $('.js-timeframe').hasClass('in'),
            zipcode = '',
            streetnr = '',
            country = '';

        if(invoiceAddressForShipping && (timeframesVisible || forceOnHidden)) {
            zipcode = $('.js-zipcode-address').val();
            streetnr = $('.js-streetnr-address').val();
            country = $('.js-country-address').val();
        } else if (timeframesVisible || forceOnHidden) {
            zipcode = $('.js-zipcode-shipping').val();
            streetnr = $('.js-streetnr-shipping').val();
            country = $('.js-country-shipping').val();
        }

        if(zipcode !== '' && streetnr !== '' && country !== '') {
            $('.js-timeframe__option, .js-timeframe__preferred-shipping-date').val('');
            $('.js-timeframe__info').addClass('hidden');
            $timeframeOptions.html($loadingIcon);

            $.ajax({
                dataType: 'json',
                method: 'POST',
                url: '/bjax/postnl/GetAvailableTimeFrames/',
                data: {
                    zipcode: zipcode,
                    houseNumber: streetnr,
                    countryCode: country.toUpperCase(),
                    shippingMethodId: shippingMethodId
                },
                success: function (json) {
                    $timeframeOptions.empty();
                    var lastDate = '';
                    $.each(json.available_times.timeFrames, function (i) {
                        var option = this.options[0];
                        var name = option.option;
                        var label = option.label;
                        var shipping = option.shipping;
                        var dateHeader = '';

                        var costs = '';
                        if (shipping > 0) {
                            costs = '+ € ' + (parseInt(shipping) / 100).toFixed(2).replace('.', ',');
                        }

                        if(lastDate != this.date) {
                            dateHeader = '<h3 class="checkout-timeframe__header"><span>' + this.dateDay + ' ' + this.dateNoYear + '</span></h3>';
                            lastDate = this.date;
                        }

                        $timeframeOptions.append(dateHeader +
                            '<div class="checkout-timeframe__option radio">' +
                            '<label for="timeframe_option_' + i + '">' +
                            '<input id="timeframe_option_' + i + '" type="radio" name="timeframe_option"' +
                                'data-option-name="' + name + '"' +
                                'data-preferred-date="' + this.date + '"' +
                                'data-plain-cost="' + shipping + '"' +
                            '>' +
                            label + ' ' + costs +
                            //'<br>' +
                            //'<i>' + this.fromNoSeconds + ' - ' + this.toNoSeconds + '</i>' +
                            '</label></div>');
                    });
                },
                error: function(XMLHttpRequest) {
                    var error = XMLHttpRequest.responseJSON;
                    var $error = $('<div/>').addClass('alert alert-danger js-timeframe__zipcode-error').text(error.message);
                    $timeframeOptions.html($error);
                }
            });
        }
    }

    $timeframeOptions.on('change', '*[name="timeframe_option"]', function() {
        var location = $(this);
        $('.js-timeframe__option').val(location.data('option-name')).valid();
        $('.js-timeframe__preferred-shipping-date').val(location.data('preferred-date'));

        var cost = location.data('plain-cost');
        update_cost(cost);
    });

    // Pick-up
    $('.js-address__trigger').on('blur.prefillZipcode', function(evt) {
        if($('.js-pickup__zipcode').val() == '') {
            var zipcode = $('.js-zipcode-shipping:visible').val() || $('.js-zipcode-address').val();
            $('.js-pickup__zipcode').val(zipcode);
        }
    });

    $('.js-pickup__zipcode').on('keypress', function(event) {
        if(event.keyCode === 13) {
            event.preventDefault();
            $('.js-pickup__submit').click();
            return false;
        }
    });

    $('.js-pickup__submit').on('click', function(event) {
        var zipcode = $('.js-pickup__zipcode').val().replace(/ /g, '');
        var country = $('.js-pickup__country').val() || $('.js-country-shipping:visible').val() || $('.js-country-address').val();
        var logos = ['Albert Heijn', 'Bruna', 'Gamma', 'Jumbo', 'Karwei', 'Plus', 'Poiesz', 'Primera', 'Spar', 'Staples Office Centre'];

        if(zipcode && country) {
            $('.js-pickup__location > input').val('');
            $pickupOptions.html($loadingIcon);

            $.ajax({
                dataType: "json",
                method: "POST",
                url: "/bjax/postnl/getNearestLocations/",
                data: {
                    zipcode: zipcode,
                    countryCode: country.toUpperCase(),
                    shippingMethodId: $('.js-shipping-method-id').val()
                },
                success: function (json) {
                    $pickupOptions.empty();
                    $.each(json.locations, function (i) {
                        var cdn = 'https://60cafc33af40b8287ffb-1a032c1af87160c7fc01b9de8fd3221e.ssl.cf3.rackcdn.com/pakjegemak/';
                        var logo = (logos.indexOf(this.name) > -1) ? this.name.replace(/\s/g, '_').toLowerCase() : 'fallback';
                        $pickupOptions.append('' +
                            '<div class="radio ' + ((i > 4) ? 'js-hidden-pickup-option collapse' : '') + '">' +
                            '<label>' +
                            '<input type="radio" name="pickup_location"' +
                                'data-location-name="' + this.name + '"' +
                                'data-location-street="' + this.address.street + '"' +
                                'data-location-streetnr="' + this.address.houseNr + '"' +
                                'data-location-zipcode="' + this.address.zipcode + '"' +
                                'data-location-city="' + this.address.city + '"' +
                                'data-location-country="' + this.address.countryCode + '"' +
                            '>' +
                            '<img src="' + cdn + logo +'.jpg" alt="' + this.name + '">' +
                            '<strong>' + this.name + '</strong><br>' +
                            this.address.street + ' ' +
                            this.address.houseNr + ', ' +
                            this.address.city +
                            '</label></div>');
                    });

                    if(json.locations.length > 4) {
                        $pickupOptions.append('' +
                            '<div data-toggle="collapse" data-parent=".js-pickup__options" data-target=".js-hidden-pickup-option, .js-more-pickup" class="btn btn-link">' +
                                '<div class="js-more-pickup collapse fade in">Toon meer</div>' +
                                '<div class="js-more-pickup collapse fade">Toon minder</div>' +
                            '</div>'
                        );
                    }
                },
                error: function(XMLHttpRequest) {
                    var error = XMLHttpRequest.responseJSON;
                    var $error = $('<div/>').addClass('alert alert-danger js-pickup__zipcode-error').text(error.message);
                    $pickupOptions.html($error);
                }
            });
        }
    });

    $pickupOptions.on('change', '*[name="pickup_location"]', function() {
        var location = $(this);
        $('.js-pickup__location-name').val(location.data('location-name')).valid();
        $('.js-pickup__location-street').val(location.data('location-street'));
        $('.js-pickup__location-streetnr').val(location.data('location-streetnr'));
        $('.js-pickup__location-zipcode').val(location.data('location-zipcode'));
        $('.js-pickup__location-city').val(location.data('location-city'));
        $('.js-pickup__location-country').val(location.data('location-country'));
    });

    // Update shipping cost
    function update_cost(cost) {
        var $shippingcost = $('.summary__shippingcost');
        var $totalcost = $('.summary__totalcost');
        var new_shipping_cost = $shippingcost.data('plain-cost') + (cost || 0);
        var new_total_cost = $totalcost.data('plain-cost') + (cost || 0);
        $shippingcost.text('€ ' + (parseInt(new_shipping_cost) / 100).toFixed(2).replace('.', ','));
        $totalcost.text('€ ' + (parseInt(new_total_cost) / 100).toFixed(2).replace('.', ','));
    }
});